import React from "react";
import { Badge } from "./ui/badge";

const STYLES = {
  pending: { label: "Pending approval", cls: "bg-amber-100 text-amber-800" },
  active: { label: "Live", cls: "bg-emerald-100 text-emerald-800" },
  rejected: { label: "Rejected", cls: "bg-red-100 text-red-700" },
};

export const StatusBadge = ({ status }) => {
  const s = STYLES[status || "active"] || STYLES.active;
  return <Badge variant="outline" className={`${s.cls} border-0`} data-testid={`status-${status || "active"}`}>{s.label}</Badge>;
};
